import { render, staticRenderFns } from "./KTCForeverPlan.vue?vue&type=template&id=6d8fdc06&"
import script from "./KTCForeverPlan.vue?vue&type=script&lang=js&"
export * from "./KTCForeverPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports